// github repo url
export const GITHUB_URL = 'https://github.com/jeecgboot/jeecgboot-vue3';

// vue-Jeecg-admin-next-doc
export const DOC_URL = 'http://vue3.jeecg.com';

// site url
export const SITE_URL = 'http://www.jeecg.com';
